import BaseUseCase from "../../base_use_case.js";

class DeleteDownloadableUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "delete",
      url: `/api/v1/admin/downloadables/downloadables/${identifier}`,
      params: {
        findBySlug: true
      },
    });
  }
}

const instance = new DeleteDownloadableUseCase();
export default instance;
